import {BaseLS} from './BaseLS';
import {IEnum} from '../../../@types/enum';

const STORAGE_KEY = 'assetFunction';

export class AssetFunction extends BaseLS<IEnum> {
  constructor() {
    super(STORAGE_KEY);
  }
}
